import axios from 'axios';

const afbankApi = axios.create( {
	baseURL         : 'https://us-central1-acordo-fechado-dev.cloudfunctions.net/af-bank-api',
	withCredentials : true
} );

afbankApi.interceptors.request.use( async config => {
	const token = localStorage.getItem( 'af-token' );
	if ( token ) {
		config.headers.Authorization = `Bearer ${token}`;
	}
	return config;
} );

export default afbankApi;

